import { useEffect } from 'react';
import './App.css';
import {
  Route,
  Routes,
} from 'react-router-dom';
import { Navbar } from './components/Navbar';
import {
  EditFeed,
  JobManager,
  ViewFeed,
} from './components/pages';
import env from './utils/config';

function App() {
  useEffect(() => {
    fetch(`${env.SERVER_URL}/api/v1/job/status`).then(resp => {
      if (!resp.ok) {
        console.error('Response not okay, body below:');
        console.error(resp.body);
      }
      // This is required for instances in which CORS is enabled on sso, because
      // for some reason our sso environments are out of parity with one another
      if(resp.url.includes('sso')) {
        window.location.href = `${resp.url}&nocache=${new Date().getTime()}`;
      }
    }).catch(e => {
      console.error(e);
      // required for instances in which cors is NOT enabled on sso
      window.location.href = `${env.SSO}${env.SSO_LOGIN}&nocache=${new Date().getTime()}`;
    });
    // deps list required or else re-render causes /login to be navigated to 20+ times. This will prevent that.
  }, []);

  return (
    <div>
      <Navbar/>
      <Routes>
        <Route path="/" element={<JobManager />}/>
        <Route path="/edit-feed" element={<EditFeed />}/>
        <Route path="/view-feed" element={<ViewFeed />}/>
      </Routes>
    </div>
  );
}

export default App;
